<template>
  <div>

    <p style="line-height: 50px;padding-left: 10px;">
      <b>{{d.PP_NAME}}</b>
      {{d.SP_ADDRESS}}
      {{d.SP_STIME}}

    </p>

    <el-table :border="1" :data="list" size="small" style="width: 100%" >
      <el-table-column prop="cname" label="公司名称" ></el-table-column>
      <el-table-column prop="ctname" label="姓名" ></el-table-column>
      <el-table-column prop="phone" label="查看联系方式" >
        <template slot-scope="scope">
          <a @click="show(scope.row)">查看联系方式</a>
        </template>
      </el-table-column>
    </el-table>

    <Modal
      v-model="modal"
      title="查看联系方式">
      <p>{{ detail.cname }}</p>
      <p>{{ detail.ctname }}</p>
      <a style="font-weight: bold" :href="'tel:' + detail.phone">{{ detail.phone }}</a>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        list:[],
        detail:{},
        d:{},
        modal:false,
      }
    },
    methods:{
      show(item){
        this.modal = true;
        this.detail = item;
      }
    },
    created() {
      let that = this;
      this.$axios.get('/api/v1/product/getcankerenopen?p='+this.$router.currentRoute.query.p).then(function(rs){
        that.list = rs.data.list;
        that.d = rs.data.d;
      });
    }

  }
</script>



// WEBPACK FOOTER //
// src/open/Jk214.vue